
































import Vue from 'vue';
import {Component} from 'vue-property-decorator'
import * as firebase from "firebase/app";
import "firebase/firestore";
import PlayerFooter from '@/components/PlayerFooter.vue'
import SideMenu from '@/components/SideMenu.vue'

@Component({
  components: {SideMenu, PlayerFooter},
})
export default class App extends Vue {
  private menu = false
  private showAlert = false

  private alertColor = "info"
  private alertMessage = ""

  private mounted() {
    const firebaseConfig = {
      apiKey: "AIzaSyAGaHajcNMqq66vnN77mTlkQ8UJNcG8aEI",
      authDomain: "jitomi-button.firebaseapp.com",
      databaseURL: "https://jitomi-button.firebaseio.com",
      projectId: "jitomi-button",
      storageBucket: "jitomi-button.appspot.com",
      messagingSenderId: "737495658679",
      appId: "1:737495658679:web:376e30f9351803492f5d32",
      measurementId: "G-23L1F4DPZ2"
    };
    firebase.initializeApp(firebaseConfig)

    this.$store.subscribe((mutation, state) => {
      if (mutation.type == 'showAlert') {
        const alertConfig = state.alertConfig
        this.alertColor = alertConfig.color
        this.alertMessage = alertConfig.msg
        this.showAlert = true
      }
    })
  }
}
